import { useMutation } from 'react-query';
import { apiDocumentServiceRepository } from 'services/repositories/implementations/ApiDocumentServiceRepository';

/**
 * Updates document status to VIEWED. This endpoint is public and doesn't require authentication.
 * @summary Mark document as viewed
 */

interface UseMarkDocumentAsViewedProps {
  onSuccess?: () => void;
  onError?: () => void;
}

interface DocumentViewedParam {
  document: {
    id: string;
    contentId: string;
    accountId: string;
    createdBy: string;
    assigneeUserId?: string;
    title: string;
  };
  viewer: {
    id: string;
    email: string | null;
  };
}

export const useMarkDocumentAsViewed = ({ onSuccess, onError }: UseMarkDocumentAsViewedProps) => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: async ({ document, viewer }: DocumentViewedParam) => {
      await apiDocumentServiceRepository.documentViewed({
        contentId: document.contentId,
        viewerId: viewer.id,
        viewerEmail: viewer.email ? viewer.email : undefined,
      });
    },
    onSuccess,
    onError,
  });

  return { mutateAsync, isLoading };
};
